"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenSizeWideMax = exports.ScreenSizeWideMin = exports.ScreenSizeXlargeMax = exports.ScreenSizeXlargeMin = exports.ScreenSizeLargeMax = exports.ScreenSizeLargeMin = exports.ScreenSizeMediumMax = exports.ScreenSizeMediumMin = exports.ScreenSizeSmallMax = exports.ScreenSizeSmallMin = exports.ScreenSizeXsmallMax = exports.ScreenSizeXsmallMin = void 0;
exports.ScreenSizeXsmallMin = "0px";
exports.ScreenSizeXsmallMax = "480px";
exports.ScreenSizeSmallMin = "480px";
exports.ScreenSizeSmallMax = "768px";
exports.ScreenSizeMediumMin = "768px";
exports.ScreenSizeMediumMax = "1024px";
exports.ScreenSizeLargeMin = "1024px";
exports.ScreenSizeLargeMax = "1280px";
exports.ScreenSizeXlargeMin = "1280px";
exports.ScreenSizeXlargeMax = "1600px";
exports.ScreenSizeWideMin = "1600px";
exports.ScreenSizeWideMax = "100000px";
